// extracted by mini-css-extract-plugin
export var errorIcon = "_pi-1";
export var nameLogo = "_pi-0";